var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "excel-export g-btn--grey",
      on: { click: _vm.submitExportExcel },
    },
    [_c("i", { staticClass: "iconfont iconxiazai" })]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }